import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import tcTranslations from './locales/tc.json';
import scTranslations from './locales/sc.json';

// Create resources object
const resources = {
    en: {
        translation: enTranslations
    },
    tc: {
        translation: tcTranslations
    },
    sc: {
        translation: scTranslations
    }
};

// Initialize i18n with promise
const initI18n = async () => {
    // Clear any existing instance
    if (i18n.isInitialized && typeof i18n.destroy === 'function') {
        await i18n.destroy();
    }

    await i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources,
            fallbackLng: {
                'sc': ['en'], // Simplified Chinese falls back to English
                'tc': ['en'], // Traditional Chinese falls back to English
                'default': ['en']
            },
            debug: false, // Disable debug mode

            // Language detection
            detection: {
                order: ['localStorage', 'navigator'],
                caches: ['localStorage'],
                lookupLocalStorage: 'i18nextLng',
                lookupSessionStorage: 'i18nextLng',
            },

            // Interpolation
            interpolation: {
                escapeValue: false,
            },

            // Load options
            load: 'languageOnly',

            // NOTE: do not enable v3 JSON compatibility — it changes plural suffix handling
            // (expects legacy `_plural` keys). We use modern `_one`/`_other` keys.

            // Add supported languages explicitly
            supportedLngs: ['en', 'tc', 'sc'],

            // Add language mapping
            lng: 'en', // Default language

            // Add whitelist to ensure all languages are available
            whitelist: ['en', 'tc', 'sc'],

            // Prevent fallback to similar languages
            nonExplicitWhitelist: false,

            // Ensure language is properly initialized
            initImmediate: false,
        });

    // Prefer this-device localStorage over a possibly stale cached profile language.
    const supported = ['en', 'tc', 'sc'];
    const normalize = (code) => (code && supported.includes(code) ? code : null);
    let dbLanguage = null;
    try {
        const token = localStorage.getItem('token');
        const userData = token ? localStorage.getItem('user') : null;
        if (userData) {
            dbLanguage = normalize(JSON.parse(userData)?.preferred_language);
        }
    } catch (error) {
        console.error('i18n: Error loading user language preference:', error);
    }

    const localLanguage = normalize(localStorage.getItem('i18nextLng'));
    const targetLanguage = localLanguage || dbLanguage || normalize(i18n.language) || 'en';
    await i18n.changeLanguage(targetLanguage);

    return i18n;
};

// Initialize immediately
initI18n();

export default i18n;
